export default "__VITE_ASSET__58d5bc60__"